import {IOGateway} from '../../gateway';
import * as metrics from './core.js';
import {conflateRepo, MetricsEvent} from './common.js';
import {basicPublisher, basicRepositoryFactory, WorkerConfig} from './publisher.js';

type CustomConfig = IOGateway.CustomMetricsPublisherConfig & WorkerConfig

export async function wrap(conf: CustomConfig): Promise<metrics.RepositoryFactory> {
    return basicRepositoryFactory(conf,
        // we need to update filters
        await basicPublisher(conf,
            (data: MetricsEvent[]) => conflateRepo(conf.split_size ?? 1, data),
            conf?.publishFn ?? '@interopio/gateway/metrics/publisher/custom'));
}
